var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0005 8.33412V11.0008M8.0005 13.6675H8.00717M6.8605 4.90745L1.21384 14.3341C1.09741 14.5357 1.03581 14.7643 1.03516 14.9971C1.03451 15.2299 1.09483 15.4589 1.21012 15.6611C1.32541 15.8634 1.49165 16.032 1.69231 16.15C1.89296 16.2681 2.12104 16.3316 2.35384 16.3341H13.6472C13.88 16.3316 14.108 16.2681 14.3087 16.15C14.5094 16.032 14.6756 15.8634 14.7909 15.6611C14.9062 15.4589 14.9665 15.2299 14.9658 14.9971C14.9652 14.7643 14.9036 14.5357 14.7872 14.3341L9.1405 4.90745C9.02166 4.71153 8.85432 4.54953 8.65463 4.43711C8.45495 4.32469 8.22966 4.26562 8.0005 4.26562C7.77135 4.26562 7.54606 4.32469 7.34637 4.43711C7.14669 4.54953 6.97935 4.71153 6.8605 4.90745Z",
    stroke: "#DC6803",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionTriangle);
export default __webpack_public_path__ + "static/media/attention-triangle.8204771bda251040bf38a9fed50c3a45.svg";
export { ForwardRef as ReactComponent };